import React, { useEffect, useRef } from "react";

const BacktoTop = () => {
  const progressRef = useRef(null);

  useEffect(() => {
    const progressPath = progressRef.current;
    const pathLength = progressPath.getTotalLength();

    progressPath.style.transition = "none";
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = "stroke-dashoffset 10ms linear";

    const updateProgress = () => {
      const scroll = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const progress = pathLength - (scroll * pathLength) / height;
      progressPath.style.strokeDashoffset = progress;
    };

    updateProgress();

    window.addEventListener("scroll", updateProgress);

    return () => {
      window.removeEventListener("scroll", updateProgress);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const backtotop = document.querySelector(".backtotop-wrap");
      const stickyHeader = document.querySelector("#rs-sticky-header");

      if (window.scrollY > 150) {
        backtotop.classList.add("active-progress");
      } else {
        backtotop.classList.remove("active-progress");
      }

      if (window.scrollY > 200) {
        stickyHeader?.classList.add("active");
      } else {
        stickyHeader?.classList.remove("active");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollTop = (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="backtotop-wrap cursor-pointer" onClick={scrollTop}>
      <svg
        className="backtotop-circle svg-content"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path
          ref={progressRef}
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
        />
      </svg>
    </div>
  );
};

export default BacktoTop;
